/* global axios */
import ApiClient from '../ApiClient';

class NexceoReportsAPI extends ApiClient {
  constructor() {
    super('nexceo/reports', { accountScoped: true });
  }

  /** Live metrics for any date range. */
  summary(params = {}) {
    return axios.get(`${this.url}/`, { params });
  }

  /** Daily metrics for a specific date (YYYY-MM-DD). */
  daily(params = {}) {
    return axios.get(`${this.url}/daily`, { params });
  }

  /** Paginated list of report snapshots. */
  snapshots(params = {}) {
    return axios.get(`${this.url}/snapshots`, { params });
  }

  /** Single snapshot detail with text_body and html_body. */
  snapshot(id) {
    return axios.get(`${this.url}/snapshots/${id}`);
  }

  /**
   * Generate a daily admin report snapshot.
   * @param {Object} payload - { date, force, deliver }
   */
  generateDaily(payload = {}) {
    return axios.post(`${this.url}/daily/generate`, payload);
  }

  /** Send latest snapshot to configured admin recipients. */
  testDailyDelivery() {
    return axios.post(`${this.url}/daily/test_delivery`);
  }
}

export default new NexceoReportsAPI();
